<div class="main-content table-page table-page--compact table-page--dense estaciones-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Estaciones de kiosco</h1>
        <p>Cada equipo tiene su propia credencial. Revocar uno perdido no toca ninguna cuenta de usuario.</p>
      </div>
    </section>

    <!--
      La credencial recién emitida. Ocupa el primer lugar de la pantalla
      a propósito: es lo único que no se puede recuperar después.
    -->
    <section class="table-page__card estaciones-page__credencial" *ngIf="credencialEmitida">
      <div class="estaciones-page__credencial-encabezado">
        <span class="material-icons">vpn_key</span>
        <div>
          <h2>Credencial de «{{ credencialEmitida.nombre }}»</h2>
          <p>Cópiela ahora. No se vuelve a mostrar y no se puede recuperar: en la base solo queda su huella.</p>
        </div>
      </div>

      <code class="estaciones-page__token">{{ credencialEmitida.tokenEnClaro }}</code>

      <div class="estaciones-page__credencial-acciones">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="copiarCredencial()">
          <span class="material-icons">content_copy</span>
          {{ copiada ? "Copiada" : "Copiar" }}
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="cerrarCredencial()">
          <span class="material-icons">close</span>
          Ya la guardé
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [(ngModel)]="nueva.idUbicacion">
                <mat-option *ngFor="let sitio of ubicaciones" [value]="sitio.id">{{ sitio.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre del equipo</mat-label>
              <input matInput aria-label="Nombre del equipo" [(ngModel)]="nueva.nombre" maxlength="120" placeholder="Recepción, Caseta norte…" />
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="emitir()">
            <span class="material-icons">add_moderator</span>
            Emitir credencial
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="estaciones.length > 0; else estacionesEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Equipo</th>
              <th>Sitio</th>
              <th>Última sincronización</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let estacion of estaciones">
              <td><strong class="table-page__name">{{ estacion.nombre }}</strong></td>
              <td><span class="table-page__text">{{ nombreUbicacion(estacion.idUbicacion) }}</span></td>
              <td><span class="table-page__text">{{ ultimaSincronizacion(estacion) }}</span></td>
              <td><span [class]="claseEstatus(estacion.estatus)">{{ estacion.estatus }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                        title="Revocar" aria-label="Revocar"
                        *ngIf="esActiva(estacion)" (click)="revocar(estacion)">
                  <span class="material-icons">gpp_bad</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #estacionesEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else estacionesLoadingState">
          <span class="material-icons">point_of_sale</span>
          <h3>No hay estaciones registradas</h3>
          <p>Emita una credencial por cada equipo con lector de huella que vaya a operar.</p>
        </div>
      </ng-template>

      <ng-template #estacionesLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando estaciones</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
